import request from '@/utils/request'



// 查询参数列表
export function pageConfig (query) {
  return request({
    url: '/config/config/page',
    method: 'get',
    params: query
  })
}

// 查询参数列表
export function listConfig (query) {
  return request({
    url: '/system/config/list',
    method: 'get',
    params: query
  })
}

// 查询参数详细
export function getConfig(data) {
  return request({
    url: '/config/config/detail',
    method: 'get',
    params: data
  })
}

// 根据参数键名查询参数值
export function getConfigKey (configKey) {
  return request({
    url: '/system/config/configKey/' + configKey,
    method: 'get'
  })
}

// 新增参数配置
export function addConfig(data) {
  return request({
    url: '/config/config/add',
    method: 'post',
    data: data
  })
}

// 修改参数配置
export function updateConfig(data) {
  return request({
    url: '/config/config/edit',
    method: 'post',
    data: data
  })
}

// 删除参数配置
// export function delConfig (configId) {
//   return request({
//     url: '/config/config/delete' + configId,
//     method: 'delete'
//   })
// }
// 删除参数配置
export function delConfig(data) {
  return request({
    url: '/config/config/delete',
    method: 'post',
    data: data
  })
}

// 刷新参数缓存
export function refreshCache () {
  return request({
    url: '/system/config/refreshCache',
    method: 'delete'
  })
}
